import CustomChartTooltip from "components/Tooltip/ChartTooltip";
import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Tooltip as ReactTooltip } from "react-tooltip";
import useAuth from "hooks/useAuth";
import { ReactComponent as InfoIcon } from "assets/icons/info_2.svg";
import useDialog from "hooks/useDialog";
import { priceChangeMockData } from "mocks/data";
import useSubscription from "hooks/useSubscription";
const SearchPriceChangeChart = ({ property }) => {
  const [data, setData] = useState([]);
  const [vtPercentage, setVtPercentage] = useState(null);
  const { user } = useAuth();
  const { subscriptionStatus } = useSubscription();
  const isPremium = subscriptionStatus.hasPremium;
  const { openSigninDialog } = useDialog();

  useEffect(() => {
    if (user && isPremium && property && property?.history) {
      // Filter out items with a price 0
      const filteredHistory = property.history.filter(
        (item) => item.sale_price > 0
      );

      // Process the history data for chart
      const formattedData = filteredHistory.map((item) => ({
        date: new Date(item.changed_at).toLocaleDateString("en-US", {
          month: "2-digit",
          year: "2-digit",
        }),
        value1: item.sale_price,
      }));
      setData(formattedData);

      // Calculate VT percentage
      const initialPrice = filteredHistory[0]?.sale_price;
      const latestPrice =
        filteredHistory[filteredHistory.length - 1]?.sale_price;

      if (initialPrice && latestPrice) {
        const percentageChange =
          ((latestPrice - initialPrice) / initialPrice) * 100;
        setVtPercentage(percentageChange.toFixed(2));
      }
    } else {
      // If the user is not logged in, use mock data
      const formattedMockData = priceChangeMockData().map((item) => ({
        date: new Date(item.changed_at).toLocaleDateString("en-US", {
          month: "2-digit",
          year: "2-digit",
        }),
        value1: item.sale_price,
      }));
      setData(formattedMockData);
    }
  }, [property, user, isPremium]);

  return (
    <div className="mt-4 lg:mt-[19px] mb-3 lg:mb-0">
      <div className="flex xs:flex-row flex-col items-start space-y-3 xs:space-y-0 xs:items-center justify-between">
        <div className="flex-1">
          <h2 className="text-[16px] md:text-[18px] lg:text-[22px] font-bold leading-[28px] text-black line-clamp-1">
            {/* {user && isPremium ? "Ultima " : ""} */}
            Storicità Annuncio
          </h2>
          <p className="mt-[2px] leading-5 text-[18px] text-[#9291A5] font-normal">
            Attività
          </p>
        </div>

        <span
          className="cursor-pointer"
          data-tooltip-id="not_subscribed_price_change_tooltip"
          data-tooltip-content="Scopri la storia completa di ogni annuncio, monitora da quanto tempo è presente sul mercato tracciando eventuali variazioni di prezzo"
        >
          <InfoIcon />
        </span>
        {/* Info Tooltip  */}
        <ReactTooltip
          id="not_subscribed_price_change_tooltip"
          place="top"
          positionStrategy="fixed"
          className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
        />
      </div>
      <div className="relative">
        {(!user || !isPremium) && (
          <div
            onClick={openSigninDialog}
            className="bg-[#FF6D59] faq-box-shadow z-[1] p-[11px] cursor-pointer rounded-[78px] max-w-[247px] absolute bottom-[55px] transform left-1/2 -translate-x-1/2"
          >
            <p className="text-[14px] font-semibold leading-[16.94px] text-center text-white">
              Iscriviti al piano Pro, per poter sbloccare le informazioni
              avanzate
            </p>
          </div>
        )}

        <hr className="mt-5 h-[1px] bg-[#E5E5EF] w-full mb-[35px]" />
        <ResponsiveContainer
          className={`price-change-chart ${
            user && isPremium ? "" : "blur-[7px]"
          }`}
          width="100%"
          height={210}
        >
          <LineChart data={data} margin={{ right: 10 }}>
            <CartesianGrid
              fill="white"
              stroke="#E5E5EF"
              horizontal={true}
              vertical={false}
              strokeWidth={0.49}
            />
            <XAxis
              dataKey="date"
              stroke="#E5E5EF"
              strokeWidth={1.5}
              tick={{ fill: "#615E83", fontSize: 12 }}
              tickMargin={10}
              tickLine={false}
              domain={["auto", "dataMax + 1000"]}
            />
            <YAxis
              width={85}
              tickFormatter={(value) =>
                new Intl.NumberFormat("en-US", {
                  notation: "compact",
                  compactDisplay: "short",
                }).format(value)
              }
              tick={{ fill: "#615E83", fontSize: 14, max: 4 }}
              tickLine={false}
              axisLine={false}
              tickMargin={30}
              tickCount={4}
              domain={["dataMin", "auto"]}
            />
            <Tooltip
              cursor={{
                stroke: "#9291A5",
                strokeWidth: 0.5,
                strokeDasharray: "5 5",
              }}
              content={<CustomChartTooltip />}
            />
            <Line
              type="monotone"
              dataKey="value1"
              stroke="#1DA1F2"
              strokeWidth={1.46}
              dot={{ r: 5 }}
              activeDot={{ r: 8, fill: "#FF718B" }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SearchPriceChangeChart;
